import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import FamilyAuthShell, { errorDetail } from "../../components/family/FamilyAuthShell";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function FamilyResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (password.length < 10) return setError("La password deve avere almeno 10 caratteri");
    if (password !== confirm) return setError("Le password non coincidono");
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API_URL}/api/family/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json().catch(() => ({}));
      if (res.status === 429) throw new Error("Troppi tentativi: riprova tra qualche minuto");
      if (!res.ok) throw new Error(errorDetail(data, "Non è stato possibile aggiornare la password"));
      setDone(true);
    } catch (err) {
      setError(err.message || "Non è stato possibile aggiornare la password");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <FamilyAuthShell>
        <div className="space-y-4 text-center">
          <h1 className="text-xl font-extrabold">Link non valido</h1>
          <p className="text-sm leading-6 text-slate-600">Il link per scegliere una nuova password è incompleto. Richiedine uno nuovo.</p>
          <Link to="/family/forgot-password" className="inline-flex h-11 w-full items-center justify-center rounded-xl bg-[#6e48b5] text-sm font-semibold text-white hover:bg-[#5a3b94]">Richiedi un nuovo link</Link>
        </div>
      </FamilyAuthShell>
    );
  }

  return (
    <FamilyAuthShell>
      {done ? (
        <div className="space-y-4 text-center" role="status">
          <h1 className="text-xl font-extrabold">Password aggiornata</h1>
          <p className="text-sm leading-6 text-slate-600">Per sicurezza sei stato disconnesso da tutti i dispositivi. Accedi con la nuova password.</p>
          <Link to="/family-login" className="inline-flex h-11 w-full items-center justify-center rounded-xl bg-[#6e48b5] text-sm font-semibold text-white hover:bg-[#5a3b94]">Vai all&apos;accesso</Link>
        </div>
      ) : (
        <>
          <div className="mb-6 text-center">
            <h1 className="text-xl font-extrabold">Scegli una nuova password</h1>
            <p className="mt-2 text-sm leading-6 text-slate-600">Almeno 10 caratteri. Il link si può usare una sola volta.</p>
          </div>
          <form onSubmit={submit} className="space-y-4" aria-label="Nuova password">
            <div className="space-y-1.5">
              <Label htmlFor="reset-password">Nuova password</Label>
              <Input id="reset-password" type="password" required minLength={10} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} className="h-11 rounded-xl" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="reset-confirm">Conferma password</Label>
              <Input id="reset-confirm" type="password" required minLength={10} autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="h-11 rounded-xl" />
            </div>
            {error ? (
              <p role="alert" className="rounded-xl bg-red-50 px-3 py-2 text-sm text-red-700">
                {error} {/scaduto|valido/i.test(error) ? <Link to="/family/forgot-password" className="font-semibold underline">Richiedi un nuovo link</Link> : null}
              </p>
            ) : null}
            <Button disabled={loading} className="h-11 w-full rounded-xl bg-[#6e48b5] hover:bg-[#5a3b94]">
              {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              Salva la nuova password
            </Button>
          </form>
        </>
      )}
    </FamilyAuthShell>
  );
}
